<app-cyclops-nav></app-cyclops-nav>
<!-- header section Start-->
<section class="cyclops header" id="home">
  <div class="header5-content">
    <div class="cyclops-header bg video-header">
      <!-- 🎥 Background Video -->
      <video autoplay muted loop playsinline class="video-bg">
        <source src="assets/images/7.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div class="video-dark-overlay"></div>

      <!-- Overlay Content -->
      <div class="video-overlay">
        <div class="container">
          <div class="row">
            <div class="col-md-10 offset-md-1">
              <div class="center-text text-center" style="justify-content: center;">
                <div>
                  <h1>
                    <span class="bold-text">About Us</span>
                    <!-- {{ header.tagLine2 }} -->
                  </h1>
                  <!-- <h6 class="header-description">
                    {{ header.description }}
                  </h6> -->
                </div>
              </div>
            </div>
          </div> 
        </div>
      </div>
    </div>
  </div>
</section>
<section class="about-us-section" id="mission">
  <div class="container-fluid">
    <div class="row align-items-center flex-column flex-lg-row">
     
      <div class="col-lg-6 content p-4">
        <div class="text-content">
          <h2 class="main-title">About Cyclops</h2>
          <hr class="red-underline" />
          <p>
        Cyclops is a defense services company focused on delivering smart, scalable, and mission-specific solutions. Our teams operate across the U.S. and Middle East, supporting defense and security organizations with the speed, reliability, and precision today’s operations demand. We don’t just meet requirements — we work shoulder-to-shoulder with our partners to design and deliver what the mission actually needs. From tactical communications to AI-driven operations support, Cyclops bridges experience, innovation, and execution."
   
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Mission Section -->
<section class="about-us-section" id="mission">
  <div class="container-fluid">
    <div class="row align-items-center flex-column flex-lg-row">
      <!-- Image -->
      <div class="col-lg-6 p-0">
        <img src="assets/images/Picture1.png" alt="Mission" class="img-fluid w-100 custom-image" />
      </div>
      <!-- Text -->
      <div class="col-lg-6 content p-4">
        <div class="text-content">
          <h2 class="main-title">MISSION</h2>
          <hr class="red-underline" />
          <p>
            CYCLOPS is committed to strengthening national and regional security by delivering innovative, compliant, and
            mission-focused defense solutions.
            We aim to be trusted partners to governments, defense organizations, and security agencies — offering proven
            technologies, reliable support, and end-to-end execution where it matters most.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Vision Section -->
<section class="about-us-section" id="vision">
  <div class="container-fluid">
    <div class="row align-items-center flex-column flex-lg-row">
      <!-- Text First on large screens -->
      <div class="col-lg-6 content p-4 order-2 order-lg-1">
        <div class="text-content">
          <h2 class="main-title">VISION</h2>
          <hr class="red-underline" />
          <p>
            To be a trusted force in global security by delivering solutions that inspire confidence, ensure readiness,
            and strengthen operational trust.
            We are driven by innovation and service excellence to build long-term capability, not just deliver products.
          </p>
        </div>
      </div>
      <!-- Image -->
      <div class="col-lg-6 p-0 order-1 order-lg-2">
        <img src="assets/images/jump.png" alt="Vision" class="img-fluid w-100 custom-image" />
      </div>
    </div>
  </div>
</section>

<!-- Approach Section -->
<section class="about-us-section" id="approach">
  <div class="container-fluid">
    <div class="row align-items-center flex-column flex-lg-row">
      <!-- Image -->
      <div class="col-lg-6 p-0">
        <img src="assets/images/Picture3.png" alt="Our Approach" class="img-fluid w-100 custom-image" />
      </div>
      <!-- Text -->
      <div class="col-lg-6 content p-4">
        <div class="text-content">
          <h2 class="main-title">APPROACH</h2>
          <hr class="red-underline" />
          <p>
            At CYCLOPS, we work side by side with our partners to turn mission requirements into real-world results.
            Our structure is lean, our response time is fast, and our decisions are grounded in operational realities.
            Whether it's system integration, field deployment, or strategic advisory, we focus on what works, not what
            looks good on paper.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Who We Serve Section -->
<section class="about-us-section" id="who-we-serve">
  <div class="container-fluid">
    <div class="row align-items-center flex-column flex-lg-row">
      <!-- Text First on large screens -->
      <div class="col-lg-6 content p-4 order-2 order-lg-1">
        <div class="text-content">
          <h2 class="main-title">WHO WE SERVE</h2>
          <hr class="red-underline" />
          <p>
            CYCLOPS supports defense and government clients across the globe, delivering ITAR-compliant, mission-ready
            capabilities through in-house manufacturing, systems integration, and tailored security solutions in UAVs,
            border security, surveillance, communications, and operational support.
          </p>
          <p style="padding-top: 50px;"><strong>Our clients include:</strong></p>
          <hr class="red-underline" style="width: 20px;"/>
          <Div class="text-content">
          <ul >
            <li>Defense ministries and armed forces</li>
            <li>Homeland security and intelligence agencies</li>
            <li>Government contractors and integrators</li>
            <li>Allied governments and security institutions</li>
          </ul>
          </Div>
        </div>
      </div>
      <!-- Image -->
      <div class="col-lg-6 p-0 order-1 order-lg-2">
        <img src="assets/images/jump2.jpg" alt="Who We Serve" class="img-fluid w-100 custom-image" />
      </div>
    </div>
  </div>
</section>


<section class="cyclops team-section" id="leadership">
  <div class="container">
    <h4 class="team-subtitle" style="padding: 20px;">LEADERSHIP TEAM</h4>
    <h2 class="section-title gradient-text text-center" style="color:#b70000 ; padding-bottom: 30px;">MEET OUR TEAM</h2>

   <div class="row justify-content-center">
      <div class="col-lg-4 col-md-6 mb-4" *ngFor="let member of teamMembers">
        <div class="team-card">
          <div class="team-image">
            <img [src]="member.image" [alt]="member.name">
            <span class="corner top-left"></span>
            <span class="corner top-right"></span>
            <span class="corner bottom-left"></span>
            <span class="corner bottom-right"></span>
          </div>
          <h5 class="team-name">{{ member.name }}</h5>
          <p class="team-role" *ngIf="member.role1">{{ member.role1 }}</p>
          <p class="team-role" *ngIf="member.role2">{{ member.role2 }}</p>
          <p class="team-company">{{ member.company }}</p>
          <div class="btn-outline-danger btn-sm mt-2" (click)="openModal(member)">
            Read More
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="custom-modal-backdrop" *ngIf="selectedMember">
  <div class="custom-modal">
    <span class="close-btn" (click)="closeModal()">&times;</span>
    <div class="modal-content-container">
      <!-- Image -->
      <div class="modal-image">
        <img [src]="selectedMember.image" [alt]="selectedMember.name">
      </div>
      <!-- Details -->
      <div class="modal-details">
        <h3>{{ selectedMember.name }}</h3>
        <p class="modal-role" *ngIf="selectedMember.role1">{{ selectedMember.role1 }}</p>
        <p class="modal-role" *ngIf="selectedMember.role2">{{ selectedMember.role2 }}</p>
        <p class="modal-company">{{ selectedMember.company }}</p>
        <div class="modal-description">
          <p [innerHTML]="selectedMember.description"></p>
        </div>
      </div>
    </div>
  </div>
</div>

</section>



<app-cyclops-footer></app-cyclops-footer>